import { render } from "./AboutUsGoals.vue?vue&type=template&id=c2e59c96&lang=pug"
import script from "./AboutUsGoals.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutUsGoals.vue?vue&type=script&setup=true&lang=js"

import "./AboutUsGoals.vue?vue&type=style&index=0&id=c2e59c96&lang=sass"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__